import { render, staticRenderFns } from "./ReportCardGradingImport.vue?vue&type=template&id=1dc45f06"
import script from "@/controllers/custom/report_card_grading/report-card-grading-import.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/report_card_grading/report-card-grading-import.js?vue&type=script&lang=js&external"
import style0 from "./ReportCardGradingImport.vue?vue&type=style&index=0&id=1dc45f06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports